function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnthropic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45px",
    height: "31px",
    viewBox: "0 0 45 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588235%,90.588235%,90.588235%)",
      fillOpacity: 1
    },
    d: "M 25.925781 0 C 25.925781 0 38.246094 30.960938 38.246094 30.960938 C 38.246094 30.960938 45 30.960938 45 30.960938 C 45 30.960938 32.679688 0 32.679688 0 C 32.679688 0 25.925781 0 25.925781 0 Z M 25.925781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588235%,90.588235%,90.588235%)",
      fillOpacity: 1
    },
    d: "M 11.632812 18.710938 C 11.632812 18.710938 15.847656 7.828125 15.847656 7.828125 C 15.847656 7.828125 20.0625 18.710938 20.0625 18.710938 C 20.0625 18.710938 11.632812 18.710938 11.632812 18.710938 Z M 12.316406 0 C 12.316406 0 0 30.960938 0 30.960938 C 0 30.960938 6.886719 30.960938 6.886719 30.960938 C 6.886719 30.960938 9.40625 24.460938 9.40625 24.460938 C 9.40625 24.460938 22.292969 24.460938 22.292969 24.460938 C 22.292969 24.460938 24.8125 30.960938 24.8125 30.960938 C 24.8125 30.960938 31.699219 30.960938 31.699219 30.960938 C 31.699219 30.960938 19.378906 0 19.378906 0 C 19.378906 0 12.316406 0 12.316406 0 Z M 12.316406 0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnthropic);
export default __webpack_public_path__ + "static/media/Anthropic.86c6150d9bbed93a40ee4cc75801e211.svg";
export { ForwardRef as ReactComponent };